import { render, staticRenderFns } from "./logDetail.vue?vue&type=template&id=7b488fb4&scoped=true&"
import script from "./logDetail.vue?vue&type=script&lang=js&"
export * from "./logDetail.vue?vue&type=script&lang=js&"
import style0 from "./logDetail.vue?vue&type=style&index=0&id=7b488fb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b488fb4",
  null
  
)

export default component.exports